module.exports = __webpack_public_path__ + "img/1441474851.ce46c8c4.jpg";